import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, Navigate} from "react-router-dom";
import { AuthService, IAuthService } from "./auth-service";
import { ILoginRequest } from "./model/dto";
import hifzcenterloginicon from '../../image/hifzcenterloginicon.png';
import { RefreshButton } from "../refresh-button/refresh-button";
import { useTouchScreenLongPressEffect } from "../touch-screen-long-press/touch-screen-long-press";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import LoginIcon  from "../../image/frontepagelogo.png";
import backGround from '../../image/frontpagebackground.png';
import Footer from "../footer/footer";
import { useAuth } from "./auth-context";

export interface Login {}

interface ILoginErrors{
  emailError: string;
  passwordError:string;
}

export function Login(props: Login) {
  const [loginState, setLoginState] = useState({} as ILoginRequest);
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
  const [redirectToNewPassword, setRedirectToNewPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [customError, setCustomError] = useState("");
  const [errorState, setErrorState] = useState({
    error: { } as ILoginErrors
  });

  const { setAuthData } = useAuth();
  const authService: IAuthService = new AuthService();

  const isLongPress = useTouchScreenLongPressEffect();

  async function handleLogin() {
    setIsLoading(true);

    if(hasError()){
      setIsLoading(false);
      return;
    } 

    const {authData, error} = await authService.login(loginState);

    if(error){
      setCustomError(error);
    }
    else{
      if (authData && authData.accessToken) {
        if(authData.isTemporaryPassword){
          setRedirectToNewPassword(true);
        }

        // Store data in localStorage
        localStorage.setItem("authData", JSON.stringify(authData));
        
        // Update auth context to trigger terms check
        setAuthData(authData);
        
        setRedirectToReferrer(true);
      }
    }

    setIsLoading(false);
  }

  function handleChangeEmail(event: any) {
    setLoginState({ ...loginState, email: event.target.value });
  }

  function handleChangePassword(event: any) {
    setLoginState({ ...loginState, password: event.target.value });
  }

  const hasError = ()=> {
 
    const errors = {error: {
      ...errorState.error, 
      emailError: (!loginState.email || !isValidEmail(loginState.email)) ? "Email is not valid" : "",
      passwordError: !loginState.password ? "Password is not valid" : "" 
     }};

    setErrorState(errors);

    if(errors.error.emailError || errors.error.passwordError){
      return true;
    }

    return false;
    
  }

  const isValidEmail = (email:any) => {
    // Email regex pattern
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function loginRender() {
    
    if(redirectToNewPassword){
      return <Navigate to="/newpassword"  />;
    }

    if (redirectToReferrer) {
      return  <Navigate to="/"  />;
    }
    
    return (
  <>
    <div
      style={{
        minHeight: "100dvh",               // fuld viewporthøjde (mobil-sikker)
        display: "flex",
        flexDirection: "column",
        backgroundImage: `url(${backGround})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* MAIN CONTENT */}
      <main
        style={{
          flex: 1,                          // fyld al plads mellem top og footer
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "24px",
          paddingBottom: "max(24px, env(safe-area-inset-bottom))",
        }}
      >
        {/* Logo + form */}
        <div
          style={{
            width: "100%",
            maxWidth: 320,
            display: "flex",
            flexDirection: "column",
            gap: 12,
            marginTop: 24,
          }}
        >
          <img
            loading="lazy"
            src={LoginIcon}
            alt="Logo"
            style={{ width: 140, height: 140, alignSelf: "center", marginBottom: 16 }}
          />

          <label style={{ fontSize: 16 }}>Email</label>
          <input
            id="email"
            onChange={handleChangeEmail}
            autoFocus
            required
            style={{
              width: "100%",
              height: 40,
              borderRadius: 4,
              border: "1px solid #D9D9D9",
              background: "#EFEFEF",
              padding: "0 10px",
            }}
            type="text"
          />
          {errorState.error.emailError && (
            <span style={{ color: "red" }}>{errorState.error.emailError}</span>
          )}

          <label style={{ fontSize: 16, marginTop: 8 }}>Password</label>
          <input
            id="password"
            onChange={handleChangePassword}
            required
            style={{
              width: "100%",
              height: 40,
              borderRadius: 4,
              border: "1px solid #D9D9D9",
              background: "#EFEFEF",
              padding: "0 10px",
            }}
            type="password"
          />
          {errorState.error.passwordError && (
            <span style={{ color: "red" }}>{errorState.error.passwordError}</span>
          )}

          {customError && <span style={{ color: "red" }}>{customError}</span>}

          <Button
            onClick={handleLogin}
            style={{
              marginLeft: 60,
              marginTop: 15,
              width: "60%",
              backgroundColor: "#197770",
              borderColor: "#197770",
              height: 44,
            }}
          >
            {isLoading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin />
                <span style={{ marginLeft: 8 }}>logger ind...</span>
              </>
            ) : (
              "Log in"
            )}
          </Button>

          {/* LINKS-BLOK: denne skubbes ned mod bunden og ender over footeren */}
          <div style={{ marginTop: "auto", textAlign: "center", paddingTop: 16 }}>
            <div style={{ marginBottom: 30 }}>
              <Link to="/resetpassword">Glemt password?</Link>
            </div>
            <div style={{ marginLeft: 5 }}>
              <Link to="/terms">Vilkår og betingelser</Link>
            </div>
          </div>
        </div>
      </main>

      {/* FOOTER ligger altid i bunden, men uden at dække links */}
      <div style={{ flexShrink: 0 }}>
        <Footer />
      </div>
    </div>
  </>
);

  }

  return loginRender();
}
